var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Common',{scopedSlots:_vm._u([{key:"transport",fn:function(){return [_c('h2',[_vm._v(_vm._s(_vm.$t('track.trackWay.belarus.h2')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }